import { render, staticRenderFns } from "./RepresentanteProfileModal.vue?vue&type=template&id=22052046&"
import script from "./RepresentanteProfileModal.vue?vue&type=script&lang=js&"
export * from "./RepresentanteProfileModal.vue?vue&type=script&lang=js&"
import style0 from "./RepresentanteProfileModal.vue?vue&type=style&index=0&id=22052046&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports